export const pieChartPalette = [
  {
    name: 'palette1',
    colors: [
      '#e74c3c',
      '#c0392b',
      '#e67e22',
      '#f39c12',
      '#2ecc71',
      '#1abc9c',
      '#3498db',
      '#8e44ad',
      '#9b59b6',
    ],
  },
  {
    name: 'palette2',
    colors: [
      '#d35400',
      '#f39c12',
      '#27ae60',
      '#16a085',
      '#2980b9',
      '#2c3e50',
      '#34495e',
      '#8e44ad',
      '#9b59b6',
    ],
  },
  {
    name: 'palette3',
    colors: [
      '#e74c3c',
      '#c0392b',
      '#95a5a6',
      '#7f8c8d',
      '#bdc3c7',
      '#566573',
      '#34495e',
      '#2c3e50',
      '#aeb6bf',
    ],
  },
  {
    name: 'palette4',
    colors: [
      '#e74c3c',
      '#f1948a',
      '#27ae60',
      '#2ecc71',
      '#52be80',
      '#1abc9c',
      '#16a085',
      '#5dade2',
      '#3498db',
    ],
  },
  {
    name: 'palette5',
    colors: [
      '#f5b7b1',
      '#f1948a',
      '#d35400',
      '#e67e22',
      '#58d68d',
      '#27ae60',
      '#82e0aa',
      '#5dade2',
      '#85c1e9',
    ],
  },
  {
    name: 'palette6',
    colors: [
      '#f5b7b1',
      '#fad7a0',
      '#f7dc6f',
      '#82e0aa',
      '#76d7c4',
      '#5dade2',
      '#aed6f1',
      '#bb8fce',
      '#a569bd',
    ],
  },
  {
    name: 'palette7',
    colors: [
      '#a93226',
      '#cd6155',
      '#f8c471',
      '#f5b041',
      '#58d68d',
      '#27ae60',
      '#7fb3d5',
      '#2e86c1',
      '#6c3483',
    ],
  },
  {
    name: 'palette8',
    colors: [
      '#e74c3c',
      '#e67e22',
      '#f39c12',
      '#58d68d',
      '#2ecc71',
      '#5dade2',
      '#aed6f1',
      '#bb8fce',
      '#9b59b6',
    ],
  },
  {
    name: 'palette9',
    colors: [
      '#6e2c00',
      '#784212',
      '#935116',
      '#aa7e00',
      '#7d6608',
      '#4d5656',
      '#616a6b',
      '#1c2833',
      '#212f3d',
    ],
  },
  {
    name: 'palette10',
    colors: [
      '#2ecc71',
      '#52be80',
      '#1abc9c',
      '#76d7c4',
      '#5dade2',
      '#85c1e9',
      '#3498db',
      '#8e44ad',
      '#9b59b6',
    ],
  },
];
